var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
export var ModalViews;
(function (ModalViews) {
    ModalViews[ModalViews["PICKUP_PICKER"] = 0] = "PICKUP_PICKER";
    ModalViews[ModalViews["NOTIFY_ME"] = 1] = "NOTIFY_ME";
})(ModalViews || (ModalViews = {}));
var initialState = {
    currentStep: 0,
    displayModal: false,
    view: ModalViews.PICKUP_PICKER,
};
export var UIContext = React.createContext(initialState);
UIContext.displayName = "UIContext";
function uiReducer(state, action) {
    switch (action.type) {
        case "SET_STEP": {
            return __assign(__assign({}, state), { currentStep: action.step });
        }
        case "NEXT_STEP": {
            var number = (state.currentStep < 3
                ? state.currentStep + 1
                : state.currentStep);
            return __assign(__assign({}, state), { currentStep: number });
        }
        case "OPEN_MODAL": {
            return __assign(__assign({}, state), { displayModal: true });
        }
        case "CLOSE_MODAL": {
            return __assign(__assign({}, state), { displayModal: false });
        }
        case "SET_MODAL_VIEW": {
            return __assign(__assign({}, state), { modalView: action.view });
        }
    }
}
export var UIProvider = function (props) {
    var _a = React.useReducer(uiReducer, initialState), state = _a[0], dispatch = _a[1];
    var openModal = function () { return dispatch({ type: "OPEN_MODAL" }); };
    var closeModal = function () { return dispatch({ type: "CLOSE_MODAL" }); };
    var setStep = function (step) {
        return dispatch({ type: "SET_STEP", step: step });
    };
    var nextStep = function () { return dispatch({ type: "NEXT_STEP" }); };
    var setModalView = function (view) {
        return dispatch({ type: "SET_MODAL_VIEW", view: view });
    };
    var value = useMemo(function () { return (__assign(__assign({}, state), { openModal: openModal,
        closeModal: closeModal,
        setStep: setStep,
        nextStep: nextStep,
        setModalView: setModalView })); }, [state]);
    return _jsx(UIContext.Provider, __assign({ value: value }, props), void 0);
};
export var useUI = function () {
    var context = React.useContext(UIContext);
    if (context === undefined) {
        throw new Error("useUI must be used within a UIProvider");
    }
    return context;
};
